import React from "react";
import { translation } from "./Translation";

const WorkStartPromptModal = ({
  lang = "fa",
  visible,
  onConfirm,
  onDismiss,
}) => {
  if (!visible) {
    return null;
  }

  return (
    <>
      <div className="bg-gray" onClick={onDismiss} />
      <div className="logout-modal work-start-modal">
        <h2 className="work-start-title">
          {translation.work_start_prompt_title[lang]
            ? translation.work_start_prompt_title[lang]
            : "ثبت ساعت شروع کاری"}
        </h2>
        <span className="ques work-start-question">
          {translation.work_start_prompt_question[lang]
            ? translation.work_start_prompt_question[lang]
            : "آیا مایل هستید ساعت شروع کاری خود را ثبت کنید؟"}
        </span>
        <div className="btns">
          <button type="button" onClick={onDismiss} className="stay">
            {translation.work_start_prompt_no[lang]
              ? translation.work_start_prompt_no[lang]
              : "خیر"}
          </button>
          <button type="button" onClick={onConfirm} className="exit work-start-yes">
            {translation.work_start_prompt_yes[lang]
              ? translation.work_start_prompt_yes[lang]
              : "بله"}
          </button>
        </div>
      </div>
    </>
  );
};

export default WorkStartPromptModal;
